import buttonGroupStyle from "../../../../../assets/jss/material-dashboard-pro-react/buttonGroupStyle.jsx";

const ButtonBarStyle = {
  ...buttonGroupStyle,
  plusButton: {
    height: "29px !important",
  },
};

export default ButtonBarStyle;
